export const BOLSA_COMERCIALES_MODULE_NAME = "bolsa_comerciales_module";

export const bolsaComercialesModuleMenuItem = {
  icon: "wallet",
  path: "/bolsa-comerciales",
};

export const bolsaComercialesModuleRoutes = [
  {
    path: "bolsa-comerciales/settings",
    name: "BolsaComercialesSettings",
    components: {
      default: () => import("./pages/BolsaComercialesSettings.vue"),
    },
    meta: {
      title: "Bolsa de comerciales — Settings",
      requiresAuth: true,
      requiresModule: BOLSA_COMERCIALES_MODULE_NAME,
    },
  },
  {
    path: "bolsa-comerciales",
    name: "BolsaComerciales",
    components: {
      default: () => import("./pages/BolsaComerciales.vue"),
    },
    meta: {
      title: "Bolsa de comerciales",
      requiresAuth: true,
      requiresModule: BOLSA_COMERCIALES_MODULE_NAME,
    },
  },
];

export default {
  moduleName: BOLSA_COMERCIALES_MODULE_NAME,
  routes: bolsaComercialesModuleRoutes,
  menuItem: bolsaComercialesModuleMenuItem,
};
